
import request from '@/utils/request'
// 查询用户个人信息
export function getUserProfile(data) {
    return request({
        url: '/business/user/profile',
        method: 'get',
        params: data
    })
}
//更新查询当前账户余额
export function saveUserFund(data) {
    return request({
        url: '/business/user/saveUserFund',
        method: 'get',
        params: data
    })
}
//PC调用支付宝接口
export function alipayPc(data) {
    return request({
        url: '/business/alipay/pc',
        method: 'get',
        params: data
    })
}

//PC调用支付宝接口
export function submitPcOrder(data) {
    return request({
        url: '/business/alipay/submitPcOrder',
        method: 'get',
        params: data
    })
}

// 查询提现记录
export function listTx(data) {
    return request({
        url: '/business/withdraw/list',
        method: 'get',
        params: data
    })
}

// 确定提现
export function saveTx(data) {
    return request({
        url: '/business/withdraw/saveWithdraw',
        method: 'get',
        params: data
    })
}

//审核提现申请
export function updateWithdraw(data) {
    return request({
        url: '/business/withdraw/updateWithdraw',
        method: 'get',
        params: data
    })
}



//获取资金明细列表
export function billingDetailList(data) {
    return request({
        url: '/business/fund/list',
        method: 'post',
        data: data
    });
}


